import React from "react";
import { recordLabel, recordStatus, type AgentOsStudioRecord } from "./agentOsStudioModel";

export function AgentStudioPanel({ agents, subagents }: { agents: AgentOsStudioRecord[]; subagents: AgentOsStudioRecord[] }): JSX.Element {
  return (
    <div className="space-y-2" data-agent-studio-panel>
      <div className="grid gap-2 md:grid-cols-2">
        {[...agents, ...subagents].slice(0, 12).map((agent, index) => (
          <article key={`${recordLabel(agent)}-${index}`} className="rounded-lg border border-white/10 bg-black/15 p-3">
            <div className="flex items-center justify-between gap-2"><span className="truncate text-xs font-medium text-jarvis-text">{recordLabel(agent)}</span><span className="text-[10px] text-jarvis-muted">{recordStatus(agent)}</span></div>
            <p className="mt-1 text-[11px] text-jarvis-muted">{typeof agent.purpose === "string" ? agent.purpose : "Kanonischer Agent-/Subagent-Readback"}</p>
            {Array.isArray(agent.activeRunIds) && agent.activeRunIds.length > 0 && <p className="mt-2 text-[10px] text-jarvis-accent">Delegation: {agent.activeRunIds.length} echte laufende Runs</p>}
          </article>
        ))}
      </div>
      {agents.length === 0 && subagents.length === 0 && <p className="rounded-lg border border-white/10 p-3 text-xs text-jarvis-muted">Keine Agenten oder Subagenten im Runtime-Readback.</p>}
      <p className="text-[10px] text-jarvis-muted">Aktivieren, Pausieren und Deprecaten laufen über die Unified Change Lane; direkte Löschung gebundener Artefakte ist nicht verfügbar.</p>
    </div>
  );
}
